import React from 'react';
import { WidgetProps } from '@rjsf/utils';
import { MarkdownContent } from '../markdown-content';
import { Widgets } from '@rjsf/bootstrap-4';

const BootstrapCheckboxWidget =
  Widgets.CheckboxWidget as React.ComponentType<any>;

export function CheckboxWidget({ label, ...props }: WidgetProps) {
  return (
    <BootstrapCheckboxWidget
      {...props}
      /* @ts-ignore */
      label={
        <MarkdownContent components={{ p: 'span' }}>{label}</MarkdownContent>
      }
    />
  );
}
